import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';
import {Partner} from '../../models/partner';
import {Observable} from 'rxjs';
import {AlertService} from '../alert.service';
import {Router} from '@angular/router';
import {UserService} from './user.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ProcessService {
  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private httpService: HttpClient,
    private alertService: AlertService,
    private router: Router,
    private userService: UserService,
    private translateService: TranslateService,
  ) {}

  /***********************************************************************************************************************
   *                                                APPELS API
   ***********************************************************************************************************************/

  //----- Code promo
  getPromoCodes() {
    return this.httpService.get(this.apiUrl + 'promoCodes/getCodes') as any;
  }

  getPromoCode(promoCode, city?, process?){
    return this.httpService.post(this.apiUrl + 'getPromoCode', {promoCode, city, process});
  }

  //----- Management général des process

  /**
   * Sauvegarde des informations relatives au user sur un process donné
   * @param process_id - le process
   * @param datas - les informations à sauvegarder en base, sous la forme {key : value}
   */
  sendProcessDatas(process_id: number, datas: any){
    return this.httpService.post(`${this.apiUrl}user/sendProcessDatas`, {
      process_id: process_id,
      datas: datas,
    });
  }

  /**
   * Fonctions calcul du % de complétion des process
   * @param user
   */
  updateProcessCompletion(user) {
    let count = 0;
    let done = 0;
    user.processes.forEach((process) => {
      count++;
      if (
        process.state &&
        (process.state.name === 'DONE' || process.state.name === 'NONEED')
      ) {
        done++;
      }
    });
    const percent = Math.round((done / count) * 100);
    this.setProcessCompletion(percent);
  }

  /**
   * Update la nationalité, la col. hasEuropeanCard du user et update le process HealthInsurance du user
   * Renvoi : {
   *   status : error || success
   *   data : msg de l'erreur || les processStates
   *   newId : inexistant si erreur || id du process state
   * }
   * @param user
   * @param state
   */
  updateHealthInsurance(user, state) {
    return this.httpService.post(`${this.apiUrl}user/updateHealthInsurance`, {
      nationality: user.nationality,
      hasEuropeanCard: user.hasEuropeanCard,
      state: state,
    });
  }

  /**
   * Renvoi la liste des jobs disponibles, si aucun : 404
   */
  getJobs() {
    return this.httpService.get(`${this.apiUrl}user/getJobs`) as any;
  }

  /**
   * API plus à jour - parcours non utilisé
   * Renvoi les partenaires MRH
   */
  getMRHPartnersOffers(){
    return this.httpService.get(`${this.apiUrl}getMRHPartnersOffers`) as any;
  }

  getAviUrl(){
    return this.httpService.get(this.apiUrl + 'getAviUrl') as any;
  }




  //----- Accommodation
  /**
   * Renvoi un array de propriétés
   * @param city
   * @param limit
   */
  getRooms(city, limit?) {
    if(limit){
      return this.httpService.get(`${this.apiUrl}user/getAccommodations/`+city+'?limit='+limit) as any;
    }
    return this.httpService.get(`${this.apiUrl}user/getAccommodations/`+city) as any;
  }

  getCityBySlug(city) {
    return this.httpService.get(`${this.apiUrl}user/getCityBySlug/`+city) as any;
  }

  getRoomsFromArticle(datas){
    return this.httpService.post(`${this.apiUrl}user/getAccommodationsFromArticle`, datas) as any;
  }

  getRoomsFromGeoloc(north, south, east, west){
    const data = {north,south, east, west} ;
    return this.httpService.post(`${this.apiUrl}user/getRoomsFromGeoloc`, data) as any;
  }


  getRoomsFromInterest(lat,lng, distance) {
    const data = {lat,lng, distance} ;
    return this.httpService.post(`${this.apiUrl}user/getAccommodationsFromInterest`, data) as any;
  }

  /**
   * Selon "action", on ajoute ou retire le logement des favoris.
   *  Renvoi le user avec les favoris modifiés
   * @param action
   * @param id
   */
  private editAccommodationFavorite(action, id){
    const userSession = JSON.parse(localStorage.getItem('userSession'));
    let fav = [];
    if (userSession.accommodationFavorites) {
      fav = userSession.accommodationFavorites.split(',');
    }
    if (action) {
      fav.push(id.toString());
      userSession.accommodationFavorites = fav.toString();
      this.userService.storeInLocal('userSession', userSession);
      return this.httpService.post(`${this.apiUrl}user/add/accommodationFavorite/`, {id: id});
    }
    const index = fav.indexOf(id.toString());
    if (index !== -1) {
      fav.splice(index, 1);
    }
    userSession.accommodationFavorites = fav.toString();
    this.userService.storeInLocal('userSession', userSession);

    return this.httpService.post(`${this.apiUrl}user/delete/accommodationFavorite/`, {id: id});
  }

  /**
   * Sauvegarde le booking en base, update hubspot pour team care, rend inutilisable le code promo s'il est associé à un user & créé une nouvelle notification agent pour le back care
   * Renvoi : error || rien
   * @param data
   */
  saveBooking(data){
    return this.httpService.post(`${this.apiUrl}housing/saveBooking`, data);
  }

  /**
   * Récupère le booking s'il existe, sinon renvoi {status: error, data : error msg}
   */
  getBooking(property_id?){
    return this.httpService.get(`${this.apiUrl}getBooking${property_id ? '/' + property_id : ''}`) as any;
  }

  getBookings(){
    return this.httpService.get(`${this.apiUrl}user/bookings`) as any;
  }

  getPendingBookings(){
    return this.httpService.get(`${this.apiUrl}user/getPendingBookings`) as any;
  }

  /**
   * Annule le booking, rembourse le user si besoin et upadte hubspot
   * Renvoi quelque chose seulement s'il y a une erreur
   */
  cancelBooking(bookingId) {
    return this.httpService.post(`${this.apiUrl}housing/cancelBooking`, {bookingId});
  }

  /**
   * Créé un lead et enregistre la page en base (pour différencier les lead importants (page paiement) des autres)
   *
   * @todo : voir si c'est utile quand on aura viré la première page booking de l'admin care
   * @param property
   * @param page
   */
  createHousingLead(property, page) {
    return this.httpService.post(`${this.apiUrl}housing/setLeads`, {property, page});
  }

  /**
   * Récupère les logements proposés par l'équipe care afin de les proposer au user.
   *
   * Retourne { rooms: any[], hasMore: boolean }
   *
   * @rooms contient les logements demandés, déjà formatés. Ne retourne pas les autres chambres du logement.
   * @hasMore indique s'il reste des datas à load.
   *
   * @param bookingId
   * @param page
   */
  getSelectedRooms(bookingId:number, page: number = 1) {
    return this.httpService.get(`${this.apiUrl}getSelectedRooms/` + bookingId + `?page=` + page) as any;
  }

  /**
   * @param city
   */
  checkValidHousingCity(city: string) {
    return this.httpService.post(`${this.apiUrl}checkValidHousingCity`, {city_id: city}  );
  }

  /**
   * @param propertyId
   * @param page
   */
  getSimilarRooms(propertyId: number, page: number) {
    return this.httpService.get(`${this.apiUrl}getSimilarRoom/` + propertyId + '?page=' + page) as any;
  }

  getHousingSteps(page) {
    return this.httpService.get(`${this.apiUrl}accommodationSteps/` + page) as any;
  }

  public sendViewerCount(type: string, objId: number, session?) {
    return this.httpService.post(`${this.apiUrl}sendViewerCount`, {obj_type: type, obj_id: objId, user: session});
  }

  public getReport(id, type) {
    return this.httpService.get(`${this.apiUrl}getReport/` + id + '?type=' + type) as any;
  }

  public sendReport(id, type, report) {
    return this.httpService.post(`${this.apiUrl}sendReport/` + id, {type: type, report: report});
  }


  /***********************************************************************************************************************
   *                                                CALCUL/UTILITIES
   ***********************************************************************************************************************/

  setProcessCompletion(value) {
    this.userService.processCompletion = value;
  }

  getProcessCompletion() {
    return this.userService.processCompletion;
  }

  /**
   * Fonction. Récupère le process depuis le userInformations
   * @param key
   */
  getProcess(key) {
    let res;
    this.userService.userInformations.processes.forEach((process) => {
      if (process.key == key) {
        res = process;
      }
    });
    return res;
  }

  /**
   * Ajoute ou retire l'id de la chambre de la liste des favoris. Update en base si un user est connecté, sinon sauvegarde en local
   *
   * @param list
   * @param id
   */
  addToFavorite(list, id) {
    const index = list.indexOf(id.toString());
    let action = 0;
    if (index !== -1) {
      list.splice(index, 1);
    } else {
      list.push(id.toString());
      action = 1;
    }
    if (this.userService.userInformations){
      if (list.join(',').length <= 255) {
        this.editAccommodationFavorite(action, id).subscribe();
      } else {
        list.splice(index, 1);
        return true;
      }
    }
    else{
      if (localStorage) {
        localStorage['tempFavorites'] = JSON.stringify(list);
      }
    }
  }

  /**
   * Fonction.
   * Set le booking en localStorage pour les users non connectés & sans booking payés
   * @param startDate
   * @param endDate
   * @param propId
   */
  setTempBooking(startDate, endDate, propId, booking_id, status, price?) {
    if (localStorage) {
      const tempBooking = {startDate: startDate, endDate: endDate, propId: propId, booking_id: booking_id, status: status};
      if (price) {
        tempBooking['reduced_reservation_fees'] = price;
      }
      localStorage['tempBooking'] = JSON.stringify(tempBooking);
    }
  }

  /**
   * Fonction
   * Récupère le booking en storage pour les users non connectés & sans booking payés
   */
  getTempBooking(force = false) {
    if (localStorage && localStorage['tempBooking'] && !force) {
      return JSON.parse(localStorage['tempBooking']);
    }
    this.getBooking().subscribe(response => {
      const booking = response.data;
      if(booking && booking.start_date && booking.end_date && booking.id ){
        this.setTempBooking( booking.start_date ,booking.end_date,booking.property_id,booking.id,booking.status );
        return JSON.parse(localStorage['tempBooking']);
      }
      else{
        return null;
      }
    });

  }

  /**
   * Permet de rediriger un user avec une snack bar d'informations pour qu'il sache si tout s'est bien passé et avec des datas, afin de communiquer entre les pages si besoin.
   *
   * Route: ActivatedRoute
   * @param openSnackValue
   * @param openSnackClass
   * @param url
   */
  public navigateWithDatas(openSnackValue: string, openSnackClass: string, url: string) {
    if (url === 'getRouterUrl') {
      url = this.router.url;
    }
    this.alertService.openSnackBar(openSnackValue, openSnackClass);
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([url]);
  }

  /**
   * Used to split 'Marché - room 2' to 'Marché' and 'room 2', for exemple, for display purpose
   * @param name : name of the property
   * @param range : 'start' or 'end'
   * @param hasDecorator : true, display | before "room x" ; false return only "room x"
   */
  public returnAccommodationRoom(name, range: string, hasDecorator: boolean) {
    const split = name.split('-');
    if (split.length > 1) {
      const room = split.find(element => element.trim().startsWith('Room') || element.trim().startsWith('Chambre'));
      if (range === 'end') {
        if (room) {
          return (hasDecorator ? ' | ' : '') + room;
        }
        return '';
      }
      split.splice(split.indexOf(room), 1);
      return split.join('  ')
    }
    if (range === 'start') {
      return name;
    }
  }

  //---------------------------------------------------------------------------------------------------------------------------------------


  //@TODO : voir avec la fonction dans le care service
  public getPartners(processKey): Observable<Partner[]> {
    return this.httpService.get<Partner[]>(
      this.apiUrl + `user/process/` + processKey + `/partners`
    );
  }


  /**
   * Tri les process selon sortName
   * @TODO : définir le tri par importance
   */
  public doSortProcesses(sortName: string, processArray, userInformations): any {
    let cateArray = [];

    switch (sortName) {
      case 'aToZ': {
        if (!processArray[0].translatedName) {
          this.getTranslatedName(processArray);
        }
        processArray.sort(function(a, b) {
          const x = a.translatedName.toUpperCase();
          const y = b.translatedName.toUpperCase();
          return x == y ? 0 : x > y ? 1 : -1;
        });
        break;
      }

      case 'popular': {
        processArray.sort((a, b) => a.index - b.index);
        break;
      }

      case 'importance': {
       // console.log('Tri a définir');
        break;
      }

      case 'order': {
        userInformations.categories.forEach(c => {
          cateArray.push({
            id: c.id,
            title: c.tag
          });
        });
        break;
      }

      default: {
        processArray.sort((a, b) => a.index - b.index);
        break;
      }
    }
    return {processes: processArray, cate: cateArray};
  }

  private getTranslatedName(processArray): any[] {
    processArray.forEach(p => {
      p['translatedName'] = this.translateService.instant('PROCESSES.' + p.key + '.TITLE');
    });
    return processArray;
  }

  updateTranslations(langue, content){
    return this.httpService.post(this.apiUrl + 'care/updateTranslations/' + langue, {content});
  }

  capturePayment(paymentSupport, data){
    return this.httpService.post(this.apiUrl + 'capturePayment/', {paymentSupport, data});
  }

}
